module.exports = __webpack_public_path__ + "img/VK.8243d2f1.svg";